import { render, staticRenderFns } from "./Retrun_policy.vue?vue&type=template&id=7b73beb5"
import script from "./Retrun_policy.vue?vue&type=script&lang=js"
export * from "./Retrun_policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports